<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2>{{ (isEdit ? 'APPLICATIONS.BTNS.EDIT_VERSION' : 'APPLICATIONS.BTNS.CREATE_VERSION') | translate }}</h2>
</div>

<div mat-dialog-content>
  <form>
    <mat-form-field class="form-field-maxi">
      <mat-label>{{ 'APPLICATIONS.VERSION' | translate }}</mat-label>
      <input matInput [(ngModel)]="version" [ngModelOptions]="{ standalone: true }" (ngModelChange)="testFormat()" required />
    </mat-form-field>
    <div class="alert alert-info" *ngIf="version && !semanticVersioningOk">
      {{ 'APPLICATIONS.MSG.INFO.SEMANTIC_VERSIONNING' | translate }}
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button class="space-h-s btn-warn" mat-raised-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button class="space-h-s btn-submit" mat-raised-button (click)="submitSelection()">{{ 'CONFIRM' | translate }}</button>
</div>
